import React from 'react';
import {
  Button,
  ButtonColor,
  ButtonSize,
  useMassUpdateServiceRequired
} from 'ui-builder';
import { usePopupFormManager } from 'features/nekst-widgets';
import CopyDetailsFieldsForm from './CopyDetailsFieldsForm';

export default function CopyDetailsFieldsButton() {

  const massUpdateService = useMassUpdateServiceRequired();

  const popupFormManager = usePopupFormManager();

  return (
    <Button
      color={ButtonColor.BLUE}
      size={ButtonSize.SMALL}
      onClick={() => {
        popupFormManager.openForm(
          <CopyDetailsFieldsForm
            ids={massUpdateService.getCheckedIds()}
          />
        );
      }}
      text="Copy"
      isDisabled={massUpdateService.getCheckedIds().length === 0}
      isFlat
      isFilled
    />
  );
}
